import React, { Component, CSSProperties } from 'react';

import { TinyEditorLayout } from './../index'

interface ITinyEditorComponentProps {
  data: string
  editState?: boolean
  className?: string
  style?: CSSProperties
  onChange: (content: string) => void
}

interface ITinyEditorComponentState {}

class TinyEditorComponent extends Component<ITinyEditorComponentProps, ITinyEditorComponentState> {
    render() {
        return (
            <TinyEditorLayout
                {...this.props}
            />
        );
    }
}

export default TinyEditorComponent;
